<template>
  <el-container class="productItem">
    <el-header>
      <!--<img :src="info.imageUrl" alt="">-->
      <el-image :src="info.imageUrl">
        <div slot="placeholder" class="image-slot">
          <!-- <img  src="~@/assets/image/product_services_null.png" alt=""> -->
          <img  src="" alt="">
        </div>
        <div slot="error" class="image-slot">
          <!-- <img  src="~@/assets/image/product_services_null.png" alt=""> -->
          <img  src="" alt="">
        </div>
      </el-image>
    </el-header>
    <el-main>
      <div class="sub_Title">{{info.title}}</div>
      <div class="brief_intro">{{info.content}}</div>
    </el-main>
    <el-footer>
      <div class="detail_btn_container">
        <el-button round class="el-button" @click =goProduct(current)>了解详情</el-button>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
    export default {
      name: "productItem",
      props: ["info","current"],
      methods:{
        goProduct(productId){
          this.$router.push({ path: '/ProductDetail', query: { plan: productId }});
        }
      }
    }
</script>

<style lang="less" scoped>
  .productItem{
     height: 415px;
     overflow: hidden;
     background:rgba(255,255,255,1);
     &:hover{
       .el-image{
         transform:scale(1.05);
         transition: transform 1s;
         -moz-transition: transform 1s;	/* Firefox 4 */
         -webkit-transition: transform 1s;	/* Safari 和 Chrome */
         -o-transition: transform 1s;	/* Opera */
       }
       img{
          width: 100%;
       }
       box-shadow:0px 3px 16px 1px rgba(0,0,0,0.1);
     }
  }
.el-header{
   padding: 0;
  overflow: hidden;
  width: 400px;
  height: 225px!important;
}
.el-image{
   width: 100%;
}
.el-main{
   padding: 12px;
  .sub_Title{
    font-size: 16px;
    text-align:left;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:22px;


  }
  .el-header{
     img{
        width: 400px;
        height: 225px;
        display: block;
     }
  }
  .brief_intro{
    font-size: 14px;
    line-height: 24px;
    color:#999;
    text-align: left;
    margin-top: 4px;
  }

  .el-button{
     float: right;

  }
  .detail_btn_container{
    border:1px solid green;
     color:#B3B3B3;
     width:102px;
     height:34px;
     border-radius:17px;
     border:1px solid rgba(230,230,230,1);
    .el-button.is-round{
       float: right;
    }

  }

}
  .el-button{
    float: right !important;
    width:102px;
    height:34px;
    border-radius:17px;
    border:1px solid rgba(230,230,230,1);
    line-height: 0.6;
  }

  .productItem{
    &:hover{
      .el-button{
        background:#39B2EC;
        color: #fff;
        background:linear-gradient(45deg,rgba(40,165,231,1) 0%,rgba(107,218,252,1) 100%);
        box-shadow:0px 9px 14px -8px rgba(57,178,236,0.6);
        border:none
      }
    }
  }




</style>
